import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// Custom modules
import { AppHelpersSearchModule } from '@app/components/helpers/search/search.module';
import { AppHelpersSearchFiltersModule } from '@app/components/helpers/search/filters/filters.module';
import { LayoutModule } from '@core/components/layout/layout.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
// Custom components
import { ApprovalsSearchMainComponent } from '@app/components/sections/approvals/search/main/main.component';
import { ApprovalsSearchFiltersComponent } from '@app/components/sections/approvals/search/filters/filters.component';

@NgModule({
  imports: [
    CommonModule,
    AppHelpersSearchModule,
    AppHelpersSearchFiltersModule,
    LayoutModule,
    HelperBoxModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  declarations: [
    ApprovalsSearchMainComponent,
    ApprovalsSearchFiltersComponent
  ],
  exports: [
    ApprovalsSearchMainComponent,
    ApprovalsSearchFiltersComponent
  ]
})
export class ApprovalsSearchModule { }
